import { useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
import { createImageUrl } from '../../../../../../../helper/Converters';

const QuickBuyModal_1 = ({ item }) => {
  const customization = staticComponentValueConverter(item?.customization);

  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  const image = createImageUrl(firstProduct?.variants?.[0]?.images?.[0]?.id);
  console.log('firstProduct', firstProduct);

  return (
    <div
      className="absolute bottom-0 left-0"
      style={{
        width: '100%',
        height: '70%',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        padding: '10px',
        backgroundColor: '#FFFFFF',
        zIndex: 10012312,
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div
            className="truncate"
            style={{
              textAlign: 'left',
              flex: 1,
            }}
          >
            {selectedProduct?.name || 'Ürün Başlığı'}
          </div>
          <div>İncele</div>{' '}
        </div>
        <div
          style={{
            textAlign: 'left',
          }}
        >
          Renk : Sarı
        </div>
        <div
          style={{
            textAlign: 'left',
          }}
        >
          Beden : 3XL
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: '20px' }}>
        <div style={{ display: 'flex', overflowX: 'scroll', gap: '10px' }}>
          <div>
            <div
              style={{
                width: 80,
                height: 80,
                backgroundColor: 'blue',
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,

                borderColor: customization?.colorVariant_DefaultVariantBorderColor,
                borderWidth: 2,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
              }}
            >
              {/* <img
              src="https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png"
              style={{ width: '100%', height: '100%' }}
            /> */}
            </div>
            <div
              style={{
                color: customization?.colorVariant_DefaultVariantTextColor,
              }}
            >
              Renk
            </div>
          </div>
          <div>
            <div
              style={{
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,
                backgroundColor: 'yellow',

                borderWidth: 2,
                borderColor: customization?.colorVariant_SelectedVariantBorderColor,

                borderRadius: customization?.colorVariant_BoxesBorderRadius,
              }}
            >
              {/* <img
              src="https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png"
              style={{ width: '100%', height: '100%' }}
            /> */}
            </div>
            <div
              style={{
                color: customization?.colorVariant_SelectedVariantTextColor,
              }}
            >
              Renk
            </div>
          </div>

          <div>
            <div
              style={{
                width: 80,
                height: 80,
                backgroundColor: 'red',
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,

                borderWidth: 2,
                borderColor: customization?.colorVariant_DefaultVariantBorderColor,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
              }}
            >
              {/* <img
              src="https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png"
              style={{ width: '100%', height: '100%' }}
            /> */}
            </div>
            <div
              style={{
                color: customization?.colorVariant_DefaultVariantTextColor,
              }}
            >
              Renk
            </div>
          </div>

          <div>
            <div
              style={{
                width: 80,
                height: 80,
                backgroundColor: 'green',
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,

                borderWidth: 2,
                borderColor: customization?.colorVariant_DefaultVariantBorderColor,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
              }}
            >
              {/* <img
              src="https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png"
              style={{ width: '100%', height: '100%' }}
            /> */}
            </div>
            <div
              style={{
                color: customization?.colorVariant_DefaultVariantTextColor,
              }}
            >
              Renk
            </div>
          </div>
          <div>
            <div
              style={{
                width: 80,
                height: 80,
                backgroundColor: 'purple',
                width: customization?.colorVariant_BoxesWidth,
                height: customization?.colorVariant_BoxesHeight,

                borderWidth: 2,
                borderColor: customization?.colorVariant_DefaultVariantBorderColor,
                borderRadius: customization?.colorVariant_BoxesBorderRadius,
              }}
            >
              {/* <img
              src="https://d9aff4nz0lkg0.cloudfront.net/mobligo/mobligo_new.f1a0e145b0fcc9ce50bd.png"
              style={{ width: '100%', height: '100%' }}
            /> */}
            </div>
            <div
              style={{
                color: customization?.colorVariant_DefaultVariantTextColor,
              }}
            >
              Renk
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', overflowX: 'scroll', gap: '10px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              minWidth: customization?.textVariant_BoxesWidth,
              minHeight: customization?.textVariant_BoxesHeight,
              padding: customization?.textVariant_BoxesPadding,
              borderRadius: customization?.textVariant_BoxesBorderRadius,
              color: customization?.textVariant_SelectedVariantTextColor,
              borderWidth: 2,
              borderColor: customization?.textVariant_SelectedVariantBorderColor,
              backgroundColor: customization?.textVariant_SelectedVariantBackgroundColor,
            }}
          >
            2XL
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              minWidth: customization?.textVariant_BoxesWidth,
              minHeight: customization?.textVariant_BoxesHeight,
              padding: customization?.textVariant_BoxesPadding,
              borderRadius: customization?.textVariant_BoxesBorderRadius,
              color: customization?.textVariant_DefaultVariantTextColor,
              borderWidth: 2,
              borderColor: customization?.textVariant_DefaultVariantBorderColor,
              backgroundColor: customization?.textVariant_DefaultVariantBackgroundColor,
            }}
          >
            3XL
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              minWidth: customization?.textVariant_BoxesWidth,
              minHeight: customization?.textVariant_BoxesHeight,
              padding: customization?.textVariant_BoxesPadding,
              borderRadius: customization?.textVariant_BoxesBorderRadius,
              color: customization?.textVariant_DefaultVariantTextColor,
              borderWidth: 2,
              borderColor: customization?.textVariant_DefaultVariantBorderColor,
              backgroundColor: customization?.textVariant_DefaultVariantBackgroundColor,
            }}
          >
            4XL
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              minWidth: customization?.textVariant_BoxesWidth,
              minHeight: customization?.textVariant_BoxesHeight,
              padding: customization?.textVariant_BoxesPadding,
              borderRadius: customization?.textVariant_BoxesBorderRadius,
              color: customization?.textVariant_DefaultVariantTextColor,
              borderWidth: 2,
              borderColor: customization?.textVariant_DefaultVariantBorderColor,
              backgroundColor: customization?.textVariant_DefaultVariantBackgroundColor,
            }}
          >
            5XL
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              minWidth: customization?.textVariant_BoxesWidth,
              minHeight: customization?.textVariant_BoxesHeight,
              padding: customization?.textVariant_BoxesPadding,
              borderRadius: customization?.textVariant_BoxesBorderRadius,
              color: customization?.textVariant_DefaultVariantTextColor,
              borderWidth: 2,
              borderColor: customization?.textVariant_DefaultVariantBorderColor,
              backgroundColor: customization?.textVariant_DefaultVariantBackgroundColor,
            }}
          >
            6XL
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              minWidth: customization?.textVariant_BoxesWidth,
              minHeight: customization?.textVariant_BoxesHeight,
              padding: customization?.textVariant_BoxesPadding,
              borderRadius: customization?.textVariant_BoxesBorderRadius,
              color: customization?.textVariant_DefaultVariantTextColor,
              borderWidth: 2,
              borderColor: customization?.textVariant_DefaultVariantBorderColor,
              backgroundColor: customization?.textVariant_DefaultVariantBackgroundColor,
            }}
          >
            7XL
          </div>
        </div>
      </div>

      <div
        style={{
          height: '50px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          borderWidth: 2,
          borderColor: '#000000',
        }}
      >
        SEPETE EKLE
      </div>
    </div>
  );
};

export default QuickBuyModal_1;
